<ng-content></ng-content>
<div class="message-container" [ngClass]="{'fixed-height': fixedHeight}">
    <div class="error-label"
         *ngIf="(showErrorMessage() && getErrorMessage())">{{ getErrorMessage() }}
    </div>
<!--    <ng-template #hintTemplate>-->
<!--        <div class="hint-label" *ngIf="hint">{{ hint }}</div>-->
<!--    </ng-template>-->
</div>
